/**
 * Decides whether the discount-code input should be offered.
 *
 * The caller supplies the purchase step rather than having it derived here. That matters for Quick
 * Purchase: its modal renders the quick checkout while the browser is still on the search-results
 * route, so a pathname lookup would report the wrong step and hide the input on the surface that
 * carries most of the traffic.
 *
 * This is also the rule the referral-coupon handoff consults before applying a code on its own,
 * through `isCheckoutDiscountCodeAvailable`. Changing what this returns changes where a referral
 * code gets applied, not only where the field renders.
 *
 * @param {object} params - Visibility inputs.
 * @param {string} params.purchaseStep - Step the input would render on, as named by `getPurchaseStepName`.
 * @param {object} [params.features] - Whitelabel feature flags.
 * @param {boolean} [params.hasDynamicPricing] - Whether the trip already carries a dynamic-pricing discount.
 * @returns {boolean} True when the input should render.
 */
export default function isDiscountCodeVisible({ purchaseStep, features, hasDynamicPricing }) {
  return (
    ['checkout', 'quickCheckout'].includes(purchaseStep) &&
    Boolean(features?.DISCOUNT_CODE_ENABLED) &&
    !(hasDynamicPricing && features?.DISCOUNT_CODE_SKIP_ON_EXISTING_DISCOUNT)
  );
}
